<h3 *ngIf="title" class="c-checkbox-list__title" [class.c-checkbox-list__title--disabled]="disabled">{{ title }}</h3>

<div #listContent class="c-checkbox-list" [style.height]="!showLimiter || showAll ? fullHeight : minHeight">
	<ng-content></ng-content>
</div>

<button *ngIf="showLimiter" (click)="toggle()" class="c-btn-link" [disabled]="disabled">
	<ng-container *ngIf="!showAll; else showLess">{{ LABEL_MORE }}</ng-container>
	<ng-template #showLess>{{ LABEL_LESS }}</ng-template>
</button>
